import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import FullPageProgress from "../../components/FullPageProgress";
import { ToastManager } from "../../components/Toast/ToastManager";
import ExploreFilter from "./ExploreFilter";
import ExploreList from "./ExploreList";
import ExploreLiveItem from "./ExploreLiveItem";
import { EXPLORE_SERVICES } from "../../services";
import "./style.scss";

const ExploreLanding = () => {
  const [loading, setLoading] = useState(false);
  const [textSearch, setTextSearch] = useState("");
  const dataFetchedRef = useRef(false);
  const [listData, setListData] = useState("");

  useEffect(() => {
    if (dataFetchedRef.current) return;
    dataFetchedRef.current = true;
    setLoading(true);
    EXPLORE_SERVICES.landing({ search: textSearch })
      .then(data => {
        if (data.code === 200) {
          setListData(data.data);
        } else {
          ToastManager.addToast({ title: data.message });
        }
      })
      .catch(err => {
        ToastManager.addToast({ title: err.message });
      })
      .finally(() => {
        setLoading(false);
        dataFetchedRef.current = false;
      });
  }, [textSearch]);

  useEffect(() => {
    if (textSearch) {
      dataFetchedRef.current = false;
    }
  }, [textSearch]);

  return (
    <React.Fragment>
      <div className="events6ix-layout-page-middle">
        <ExploreFilter setTextSearch={setTextSearch} textSearch={textSearch} />

        <div className="event-page-explore-content-">
          {listData?.live ? (
            <ExploreLiveItem listData={listData?.live?.[0]} />
          ) : null}
          {listData?.replays ? (
            <>
              <div className="event-page-explore-content-typeHeader">
                <div className="event-page-explore-content-typeHeader-heading">
                  Recent Live Streams
                </div>
                <Link
                  to="/explore/list/replays"
                  className="event-page-explore-content-typeHeader-btn"
                >
                  View all
                </Link>
              </div>
              <ExploreList
                layout3={true}
                loading={loading}
                listData={listData?.replays}
              />
            </>
          ) : null}

          {listData?.upcoming ? (
            <>
              <div className="event-page-explore-content-typeHeader">
                <div className="event-page-explore-content-typeHeader-heading">
                  Upcoming
                </div>
                <Link
                  to="/explore/list/upcoming"
                  className="event-page-explore-content-typeHeader-btn"
                >
                  View all
                </Link>
              </div>
              <ExploreList
                layout3={true}
                loading={loading}
                listData={listData?.upcoming}
              />
            </>
          ) : null}

          {listData?.demand ? (
            <>
              <div className="event-page-explore-content-typeHeader">
                <div className="event-page-explore-content-typeHeader-heading">
                  Pending Replay
                </div>
                <Link
                  to="/explore/list/get-notified-of-replays"
                  className="event-page-explore-content-typeHeader-btn"
                >
                  View all
                </Link>
              </div>
              <ExploreList
                layout3={true}
                loading={loading}
                listData={listData?.demand}
              />
            </>
          ) : null}
          {loading ? <FullPageProgress fixed={true} /> : null}
        </div>
      </div>
    </React.Fragment>
  );
};

export default ExploreLanding;
